import { useMemo } from 'react'
import type { RunStatus } from './useRouteOptimization'
import { useWebSocketStore } from './websocket/useWebsocket'

function generateLockedOrders(runStatus: RunStatus[], lockedOrders: Gravitate.Order[]) {
  return lockedOrders.map((order) => {
    const lockedOrder = runStatus.find((run) => run.run_id === order.run_id)
    return { ...order, ...lockedOrder }
  })
}

export const useLockedOrders = () => {
  const runStatus = useWebSocketStore((state) => state().runStatus)
  const lockedOrders = useWebSocketStore((state) => state().lockedOrders)
  const orders = useMemo(() => generateLockedOrders(runStatus, lockedOrders), [runStatus, lockedOrders])

  return {
    lockedOrders: orders,
  }
}
